/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AttachmentFileApiModel } from './attachmentFileApiModel';
import { ProviderApiModel } from './providerApiModel';
import { OrderContentType } from './orderContentType';
import { AssessedWorkActivityApiModel } from './assessedWorkActivityApiModel';
import { EmployerApiModel } from './employerApiModel';
import { AssessmentExaminationApiModel } from './assessmentExaminationApiModel';
import { EmployeeApiModel } from './employeeApiModel';
import { AssessmentStatus } from './assessmentStatus';
import { AssessedCourseApiModel } from './assessedCourseApiModel';
import { OccupationApiModel } from './occupationApiModel';
import { WorkplaceApiModel } from './workplaceApiModel';
import { AssessedRiskFactorApiModel } from './assessedRiskFactorApiModel';
import { AssessmentResult } from './assessmentResult';
import { AssessmentTypeEnum } from './assessmentTypeEnum';


export interface OrderDetailsApiModel { 
    id: number;
    status: AssessmentStatus;
    number: string;
    type: AssessmentTypeEnum;
    createDate: string;
    orderDate?: string | null;
    plannedDate?: string | null;
    issueDate?: string | null;
    employer: EmployerApiModel;
    employee: EmployeeApiModel;
    provider?: ProviderApiModel | null;
    occupation: OccupationApiModel;
    workplace: WorkplaceApiModel;
    assessedRiskFactors: Array<AssessedRiskFactorApiModel>;
    assessedWorkActivities: Array<AssessedWorkActivityApiModel>;
    assessedCourses: Array<AssessedCourseApiModel>;
    orderContentType: OrderContentType;
    examinations: Array<AssessmentExaminationApiModel>;
    orderResultStatus: AssessmentResult;
    attachments: Array<AttachmentFileApiModel>;
}
export namespace OrderDetailsApiModel {
}


